var render = function render(){
  var _vm$comments;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.isPreview ? _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Notes *"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "5",
      "placeholder": "Type your comment here..."
    },
    model: {
      value: _vm.formComment.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.formComment, "comment", $$v);
      },
      expression: "formComment.comment"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-primary w-100",
    attrs: {
      "disabled": !_vm.formComment.comment,
      "type": "button"
    },
    on: {
      "click": function click($event) {
        _vm.formComment.comment = '';
      }
    }
  }, [_vm._v("Cancel & Close")])]), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "disabled": !_vm.formComment.comment,
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.saveComment();
      }
    }
  }, [_vm._v("Submit Comment")])])], 1) : _vm._e(), _c('div', {
    staticClass: "overflow-auto d-flex w-100",
    staticStyle: {
      "max-height": "400px"
    }
  }, [((_vm$comments = _vm.comments) === null || _vm$comments === void 0 ? void 0 : _vm$comments.length) > 0 ? [_c('MaintenanceLogs', {
    attrs: {
      "logs": _vm.comments,
      "namekey": "created_by",
      "datekey": "create_at",
      "descriptionkey": "comment"
    }
  })] : _c('span', {
    staticClass: "text-muted text-center"
  }, [_vm._v("Tidak ada komentar.")])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }